<template>
  <Dialog header="Editar Usuário" :visible.sync="display" :containerStyle="{ width: '430px' }" :modal="true">
    <div class="col-12 mb-4">
      <h6>Nome</h6>
      <InputText type="text" v-model="form.name" class="w-100" />
    </div>

    <div class="col-12 mb-4">
      <h6>E-mail</h6>
      <InputText type="text" v-model="userEmail" class="w-100 bg-light" readonly />
    </div>

    <div class="col-12 mb-4">
      <h6>Senha</h6>
      <InputText type="text" v-model="form.password" class="w-100" />
    </div>

    <div class="col-12 mb-4">
      <h6>Confirmar Senha</h6>
      <InputText type="text" v-model="form.password_confirm" class="w-100" />
    </div>

    <div class="col-12 mb-5">
      <h6>Situação [{{ form.active? 'Ativo' : 'Desativado' }}]</h6>
      <InputSwitch v-model="form.active" />
    </div>

    <template #footer>
      <Button label="Cancelar" icon="pi pi-times" @click="closeModal()" class="p-button-sm p-button-secondary" />
      <Button :label="buttons.edit.label" icon="pi pi-check" @click="editUser(userId)" class="p-button-sm p-button-primary" :disabled="buttons.edit.disabled" />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputSwitch from 'primevue/inputswitch'

export default {
  name: 'ModalEdit',

  components: {
    Dialog,
    Button,
    InputText,
    InputSwitch
  },

  data() {
    return {
      userId: 0,
      userEmail: '',

      form: {
        name: '',
        password: '',
        password_confirm: '',
        active: ''
      },

      buttons: {
        edit: {
          label: 'Editar',
          disabled: false
        }
      },

      display: false
    }
  },

  methods: {
    async editUser(id) {
      if (this.form.password && this.form.password !== this.form.password_confirm) {
        this.$toastr.e('As senhas estão diferentes!', 'Erro')
        return
      }

      this.buttons.edit.label = 'Editando...'
      this.buttons.edit.disabled = true

      await this.$api.put(`/users/${id}`, this.form)
        .then((response) => {
          this.$parent.$parent.users = this.$parent.$parent.users.map(obj => obj.id === id ? response.data.user : obj);
          this.$toastr.s('Usuário editado com sucesso!', 'Sucesso')
          this.closeModal()     
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.message, 'Erro')
        })
        .finally(() => {
          this.buttons.edit.label = 'Editar'
          this.buttons.edit.disabled = false
        })
    },

    openModal(data) {
      this.userId = data.id
      this.userEmail = data.email

      this.form.name = data.name
      this.form.password = ''
      this.form.password_confirm = ''
      this.form.active = data.active
      this.display = true
    },

    closeModal() {
      this.display = false
    }
  }
}
</script>

<style></style>